import { createContext } from "react";

import type { TitleOverrideContextValue } from "./types";

export const TitleOverrideContext =
  createContext<TitleOverrideContextValue | null>(null);
TitleOverrideContext.displayName = "TitleOverrideContext";
